const Menu = {
    buildMenu: (zones, stores) => {
        const tmpMenu = zones.map((zone) => {
            const zoneTmp = {
                type: 'second_level',
                label: zone.name,
                id: zone.id,
                items: [],
            };

            if (stores[zone.id]) {
                zoneTmp.items = stores[zone.id].map((item) => {
                    const store = {
                        id: item.id,
                        label: item.name,
                    };
                    return store;
                });
            }
            return zoneTmp;
        });
        return tmpMenu;
    },
};

export default Menu;



/** WEBPACK FOOTER **
 ** ./src/components/shared/dropdown-build-menu.js
 **/